.lowMenu {
  z-index: 2;
  position: absolute;
  margin: 0px;
  transition: opacity 0.3s linear;
}

.lowMenuButtonHolder {
  border: 2px solid rgb(17, 20, 24);
  border-top-right-radius: 4px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: rgb(17, 20, 24);
  box-shadow: 2px 2px 2px rgb(64, 64, 64, 0.5);
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 2px;
  row-gap: 2px;
  width: fit-content;
}

.lowMenu.hidden {
  opacity: 0;
}

.lowMenu.visible,
.lowMenu:hover {
  opacity: 1;
}

.lowMenuItem {
  background-color: rgb(251, 253, 246);
  border: 0;
  color: rgb(17, 20, 24);
  cursor: pointer;
  padding: 0 4px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  white-space: nowrap;
}

.lowMenuItem.disabled {
  background-color: rgba(200, 200, 200);
  cursor: not-allowed;
}

.lowMenuItem:not(.disabled):hover {
  background-color: rgb(251, 233, 230);
}

.lowMenu-item .caretHolder {
  align-self: flex-end;
}

.lowMenuItem .caretHolder .subMenu {
  z-index: 1;
  position: relative;
}
